export const DEFAULTS = {
  header: 'site-header',
  nav: 'site-header__nav',
  state: 'data-comp-header-state',
  scrollAmount: 'data-comp-header-scroll-amount',
};

export const STATES = {
  scrolled: 'scrolled',
  visible: 'visible',
};
